window.check_bought_together_product = function(init) {
  console.log('check_bought_together_product: ', init);
  const add_btn_texts = ['Add to Cart', 'Add both to Cart', 'Add all three to Cart', 'Add all four to Cart', 'Add all five to Cart', 'Add all six to Cart', 'Add all seven to Cart', 'Add all eight to Cart', 'Add all nine to Cart'];
  let total_price_highlight = 0;
  let total_price_compare = 0;
  let price_before = '';
  let price_after = '';
  let bought_together_product_count = 0;
  let lat_product_id = '';
  document.querySelectorAll('.bt_item').forEach((bt_product) => {
    let product_id = bt_product.dataset.productId;
    let option_all = bt_product.querySelector('.option_all');
    let cst_check = bt_product.querySelector('.check-input');
    if (init) {
      if (option_all.selectedOptions[0].dataset.available === 'true') {
        cst_check.checked = true;
      } else {
        cst_check.checked = false;
        cst_check.disabled = true;
        bt_product.querySelector('.sold_out_btn').classList.remove('pre-hide');
      }
    }
    price_before = option_all.selectedOptions[0].dataset.price[0];
    let prices = option_all.selectedOptions[0].dataset.price.split(' ');
    if (prices.length > 1) {
      price_after = ' ' + prices[1].trim();
    }
    if (cst_check.checked) {
      lat_product_id = product_id;
      document.querySelector('#bt-img-' + product_id).classList.remove('pre-hide');
      bought_together_product_count += 1;
      total_price_highlight += option_all.selectedOptions[0].dataset.price.split(' ')[0].substr(1) * 1;
      if (option_all.selectedOptions[0].dataset.compareAtPrice) {
        total_price_compare += option_all.selectedOptions[0].dataset.compareAtPrice.split(' ')[0].substr(1) * 1;
      } else {
        total_price_compare += option_all.selectedOptions[0].dataset.price.split(' ')[0].substr(1) * 1;
      }
    } else {
      document.querySelector('#bt-img-' + product_id).classList.add('pre-hide');
    }
  });
  document.querySelectorAll('.bought_together_images .image').forEach((bt_image) => {
    if (bt_image.id === 'bt-img-' + lat_product_id) {
      bt_image.querySelector('.plus').classList.add('pre-hide');
      bt_image.classList.add('last-image');
    } else {
      bt_image.querySelector('.plus').classList.remove('pre-hide');
      bt_image.classList.remove('last-image');
    }
  });
  if (add_btn_texts[bought_together_product_count-1]) {
    document.querySelector('.bought_together_total .add_btn').innerHTML = add_btn_texts[bought_together_product_count-1];
  } else {
    document.querySelector('.bought_together_total .add_btn').innerHTML = 'please select product!'
  }
  console.log('total_price_highlight: ' + total_price_highlight + '  total_price_compare: ' + total_price_compare);
  document.querySelector('.price--highlight.total').innerHTML = price_before + total_price_highlight.toFixed(2) + price_after;
  if (total_price_compare !== total_price_highlight) {
    document.querySelector('.price--compare.total').innerHTML = price_before + total_price_compare.toFixed(2) + price_after;
  } else {
    document.querySelector('.price--compare.total').innerHTML = '';
  }
  if (total_price_highlight > 0) {
    document.querySelector('.bought_together_total .add_btn').classList.remove('disabled');
  } else {
    document.querySelector('.bought_together_total .add_btn').classList.add('disabled');
  }
};

class BoughtTogetherProduct extends HTMLElement {
  constructor() {
    super();
    this.is_main_product = this.classList.contains('bt_item_main');
    this.product_id = this.dataset.productId;
    this.check = this.querySelector('.check-input');
    this.sold_out_btn = this.querySelector('.sold_out_btn');
    this.price_highlight = this.querySelector('.price--highlight');
    this.price_compare = this.querySelector('.price--compare');
    this.option_all = this.querySelector('.option_all');
    this.option_items = this.querySelectorAll('.option_item');
    this.option_items.forEach((option_item) => {
      option_item.addEventListener('change', this.onOptionChange.bind(this));
    });
    this.check.addEventListener('change', this.onCheckClick.bind(this));
  }

  onCheckClick() {
    window.check_bought_together_product(false);
  }

  onOptionChange() {
    let options = [];

    this.option_items.forEach((option_item) => {
      options.push(option_item.selectedOptions[0].value);
    });
    console.log(options.join(' / '));

    this.option_all.querySelectorAll('option').forEach((option) => {
      if (option.innerHTML === options.join(' / ')) {
        option.selected = true;
        this.price_highlight.innerHTML = option.dataset.price;
        if (option.dataset.compareAtPrice) {
          this.price_compare.innerHTML = option.dataset.compareAtPrice;
          this.price_compare.classList.remove('pre-hide');
        } else {
          this.price_compare.classList.add('pre-hide');
        }
        console.log('option.dataset.available === "false": ', option.dataset.available === "false")
        if (option.dataset.available === "false") {
          this.sold_out_btn.classList.remove('pre-hide');
          this.check.checked = false;
          if (!this.is_main_product) {
            this.check.disabled = true;
          }
        } else {
          this.sold_out_btn.classList.add('pre-hide');
          this.check.checked = true;
          if (!this.is_main_product) {
            this.check.disabled = false;
          }
        }
        window.check_bought_together_product(false);
        return true;
      }
    });
  }
}

customElements.define('bought-together-product', BoughtTogetherProduct);

const bought_together_product_add_btn = document.querySelector('.bought_together_total .add_btn');
if (bought_together_product_add_btn) {
  window.check_bought_together_product(true);
  document.querySelector('.product_bought_together').classList.remove('pre-hide');

  bought_together_product_add_btn.addEventListener('click', function () {
    bought_together_product_add_btn.disabled = true;
    let bought_together_products = [];
    document.querySelectorAll('.bought-together-product').forEach((bt_product) => {
      let cst_check = bt_product.querySelector('.check-input');
      if (cst_check.checked) {
        bought_together_products.push({id: bt_product.querySelector('.option_all').selectedOptions[0].value, quantity: 1});
      }
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items: bought_together_products})
    }).then(response => {
      return response.json();
    }).then(data => {
      console.log(data);
      window.location.href = '/cart';
    }).catch((error) => {
      bought_together_product_add_btn.disabled = false;
      console.log('Error:', error);
    });

  });
}